import { RouteName } from '@/shared/enums';

export default [
  {
    path: '/',
    name: RouteName.HOME,
    component: () => import('../views/home/index.vue'),
    alias: '/home',
    meta: {
      label: 'main',
    },
  },
  {
    path: '/kids',
    name: RouteName.KIDS_HOME,
    component: () => import('../views/home/index.vue'),
    meta: {
      label: 'kids_main',
    },
  },
  {
    path: '/index',
    name: RouteName.INDEX,
    component: () => import('../views/index/index.vue'),
    meta: {
      label: 'index',
    },
  },
  {
    path: '/blank',
    name: RouteName.BLANK,
    component: {
      render(c) {
        return c();
      },
    },
    meta: {
      navigateDirectly: true,
    },
  },
  {
    path: '/compatibility-test',
    name: RouteName.COMPATIBILITY_TEST,
    component: () => import('../views/compatibility-test/index.vue'),
    meta: {
      label: 'compatibility-test',
    },
  },
  {
    path: '/contact',
    name: RouteName.CONTACT,
    component: () => import('../views/contact/index.vue'),
    meta: {
      label: 'contact',
    },
  },
  {
    path: '/diagnostic',
    name: RouteName.DIAGNOSTIC,
    component: () => import('../views/diagnostic/index.vue'),
    meta: {
      label: 'diagnostic',
      noindex: true,
    },
  },
  {
    path: '/faq',
    name: RouteName.FAQ,
    component: () => import('../views/faq/index.vue'),
    meta: {
      label: 'faq',
      noindex: true,
    },
  },
  {
    path: '/search',
    name: RouteName.SEARCH,
    component: () => import('../views/search/index.vue'),
    meta: {
      label: 'search',
      noindex: true,
    },
    beforeEnter: (to, from, next) => {
      if (to.query.q) {
        return next({ path: 'search', query: { query: to.query.q } });
      }

      next();
    },
  },
  {
    path: '/page/:alias',
    name: RouteName.STATIC_PAGE,
    component: () => import('../views/static-page/index.vue'),
    meta: {
      navigateDirectly: true,
    },
  },
  {
    path: '/subscriber/login',
    name: RouteName.SUBSCRIBER_LOGIN,
    component: () => import('../views/subscriber/login.vue'),
    meta: {
      label: 'login',
      anonymousOnly: true,
    },
  },
  {
    path: '/subscriber/agreements',
    name: RouteName.SUBSCRIBER_AGREEMENTS,
    component: () => import('../views/subscriber/agreements.vue'),
    meta: {
      label: 'agreements',
      requireAuth: true,
      noindex: true,
    },
  },
  {
    path: '/subscriber/password/request',
    name: RouteName.SUBSCRIBER_PASSWORD_REQUEST,
    component: () => import('../views/subscriber/password-request.vue'),
    meta: {
      label: 'password-request',
      noindex: true,
    },
  },
  {
    path: '/subscriber/password/reset',
    name: RouteName.SUBSCRIBER_PASSWORD_RESET,
    component: () => import('../views/subscriber/password-reset.vue'),
    meta: {
      label: 'password-reset',
      onboardingStep: 3,
      noindex: true,
    },
  },
  {
    path: '/subscriber/suspended',
    name: RouteName.SUBSCRIBER_SUSPENDED,
    component: () => import('../views/subscriber/suspended.vue'),
    meta: {
      label: 'suspended',
      requireAuth: true,
      noindex: true,
    },
  },
  {
    path: '/subscriber/register',
    name: RouteName.SUBSCRIBER_REGISTER,
    component: () => import('../views/subscriber/register.vue'),
    meta: {
      label: 'register',
      onboardingStep: 1,
      anonymousOnly: true,
    },
  },
  {
    path: '/subscriber/mail/verify',
    name: RouteName.SUBSCRIBER_MAIL_VERIFY,
    component: () => import('../views/subscriber/mail-verify.vue'),
    meta: {
      label: 'mail-verify',
      onboardingStep: 2,
      noindex: true,
    },
  },
  {
    path: '/subscriber/phone/verify',
    name: RouteName.SUBSCRIBER_PHONE_VERIFY,
    component: () => import('../views/subscriber/phone-verify.vue'),
    meta: {
      label: 'phone-verify',
      onboardingStep: 2,
      noindex: true,
    },
  },
  {
    path: '/subscriber/user-setup',
    name: RouteName.SUBSCRIBER_USER_SETUP,
    component: () => import('../views/subscriber/user-setup.vue'),
    meta: {
      label: 'user-setup',
      requireAuth: true,
      adultsOnly: true,
      noindex: true,
    },
  },
  {
    path: '/subscriber/my-list',
    name: RouteName.SUBSCRIBER_MY_LIST,
    component: () => import('../views/subscriber/my-list.vue'),
    meta: {
      label: 'my-list',
      requireAuth: true,
      noindex: true,
    },
  },
  {
    path: '/subscriber/my-list/:page',
    name: RouteName.SUBSCRIBER_MY_LIST_PAGE,
    component: () => import('../views/subscriber/my-list.vue'),
    meta: {
      label: 'my-list',
      requireAuth: true,
      noindex: true,
    },
  },
  {
    path: '/subscriber/my-account',
    name: RouteName.SUBSCRIBER_MY_ACCOUNT,
    component: () => import('../views/subscriber/my-account/index.vue'),
    meta: {
      label: 'my-account',
      preventScrollTop: true,
      requireAuth: true,
      adultsOnly: true,
      noindex: true,
    },
  },
  {
    path: '/:label/:slug,:type-:id',
    name: RouteName.DETAIL,
    component: () => import('../views/detail/index.vue'),
    meta: {
      preventScrollHandle: true,
    },
  },
  {
    path: '/:label/sections/:slug,:id',
    name: RouteName.DETAIL_SECTION,
    component: () => import('../views/detail/section/index.vue'),
    meta: {
      preventScrollTop: true,
    },
  },
  {
    path: '/:label/:slug,:type-:id/:articleSlug,:articleType-:articleId',
    name: RouteName.DETAIL_WITH_ARTICLE,
    component: () => import('../views/detail/index.vue'),
    meta: {
      preventScrollHandle: true,
    },
  },
  {
    path: '/:label',
    name: RouteName.CATALOG,
    component: () => import('../views/catalog/index.vue'),
    meta: {
      preventScrollTop: true,
    },
  },
  {
    path: '/:label/:slug,:id',
    name: RouteName.CATALOG_WITH_CATEGORY,
    component: () => import('../views/catalog/index.vue'),
    meta: {
      preventScrollTop: true,
    },
  },
  {
    path: '*',
    name: RouteName.NOT_FOUND,
    component: () => import('../views/not-found/index.vue'),
    meta: {
      label: 'not-found',
      navigateDirectly: true,
      noindex: true,
    },
  },
  {
    path: '*',
    name: RouteName.ERROR,
    component: () => import('../views/error/index.vue'),
    meta: {
      label: 'error',
      navigateDirectly: true,
      noindex: true,
    },
  },
];
